import React, { useEffect, useState } from 'react';

const CountryAvailability: React.FC<{ text: string }> = ({ text }) => {
  const [data, setData] = useState({
    isVisible: false,
    message: '',
  });

  useEffect(() => {
    setData({
      isVisible: true,
      message: text,
    });
  }, [text]);

  return data.isVisible ? (
    <div data-test-id="pg-warning" className="inline flex-1 text-md font-normal">
      <span data-test-id="pg-message">{data.message}</span>
    </div>
  ) : null;
};

export default CountryAvailability;
